import { lazy, Suspense } from "react";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import InsuranceSolutions from "./pages/InsuranceSolutions";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { Toaster } from "@/components/ui/sonner";

// Prerendered routes (Home, InsuranceSolutions) are imported eagerly so the
// static-prerender pass emits their full content inline (visible, not behind a
// Suspense/hidden-reveal boundary) — best for crawlers and AI agents — and the
// client hydrates a matching tree with no flash.
//
// NotFound is the ONE exception: it never appears in a prerendered route, only
// on the client-rendered 404 shell, so it stays code-split out of the bundle.
const NotFound = lazy(() => import("./pages/NotFound"));

function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/insurance-solutions"} component={InsuranceSolutions} />
      <Route path={"/privacy-policy"} component={Privacy} />
      <Route path={"/terms"} component={Terms} />
      <Route path={"/404"} component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <Toaster />
        <Suspense fallback={<div className="min-h-screen bg-background" />}>
          <Router />
        </Suspense>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
